import rrssb from 'rrssb/js/rrssb.min';

jQuery('.rrssb-buttons').rrssb({
});